:host {
  display: flex;
  flex-flow: wrap;
  align-self: center;
  justify-content: center;
  width: 100%;
  gap: 8px;
}

.date-fields-container {
  width: 100%;
}

.date-fields-label {
  margin-bottom: 4px;
}

.date-fields-inputs {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.date-input-wrapper {
  flex: 1 0 25%;
}

.radio-fields-container {
  width: 100%;
  margin: 4px 0;
}

.radio-group-label {
  margin-bottom: 4px;
}

.radio-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.radio-option {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 15px;
  line-height: 20px;
}

.radio-control {
  flex: 0 0 18px;
  width: 18px;
  height: 18px;
  box-sizing: border-box;
  border: 1px solid var(--om-radio-colour, #000);
  border-radius: 50%;
  background-color: #fff;
  display: grid;
  place-items: center;
}

.radio-input:checked + .radio-control::after {
  content: '';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--om-radio-colour, #000);
}

.radio-input:focus-visible + .radio-control {
  outline: 2px solid var(--om-radio-colour, #000);
  outline-offset: 2px;
}
